(() => {
  function parseBoolean(value) {
    return String(value).toLowerCase() === 'true';
  }

  function formatDate(date) {
    const locale = document.documentElement.lang || undefined;
    const weekday = date.toLocaleString(locale, { weekday: 'short' }).replace(/\.$/, '');
    const day = date.getDate();
    const month = date.toLocaleString(locale, { month: 'short' }).replace(/\.$/, '');
    return `${weekday}, ${day} ${month}`;
  }

  function isWeekend(date) {
    const d = date.getDay();
    return d === 0 || d === 6;
  }

  function isHoliday(date, holidays) {
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const key = `${mm}-${dd}`;
    return holidays.includes(key);
  }

  function addBusinessDays(startDate, daysToAdd, disableWeekends, holidays) {
    const date = new Date(startDate);
    let remaining = daysToAdd;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (disableWeekends && isWeekend(date)) continue;
      if (isHoliday(date, holidays)) continue;
      remaining -= 1;
    }
    return date;
  }

  function applyEstimatedDelivery(root) {
    const cutoff = root.dataset.shipCutoff || '15:00';
    let handlingDays = parseInt(root.dataset.handlingDays || '1', 10);
    let transitMinDays = parseInt(root.dataset.transitMinDays || '2', 10);
    let transitMaxDays = parseInt(root.dataset.transitMaxDays || '5', 10);
    const disableWeekends = parseBoolean(root.dataset.disableWeekends || 'true');
    const holidays = (() => {
      try { return JSON.parse(root.dataset.holidays || '[]'); }
      catch { return []; }
    })();
    const rules = (() => {
      try { return JSON.parse(root.dataset.rules || '[]'); }
      catch { return []; }
    })();
    const currentCountry = root.dataset.currentCountry || '';

    // Apply first matching rule by country code (ISO2) or 'default'
    if (rules && rules.length) {
      const match = rules.find(r => (r.country || '').toUpperCase() === currentCountry.toUpperCase()) || rules.find(r => (r.country || '').toLowerCase() === 'default');
      if (match) {
        if (typeof match.handling_days === 'number') handlingDays = match.handling_days;
        if (typeof match.transit_min_days === 'number') transitMinDays = match.transit_min_days;
        if (typeof match.transit_max_days === 'number') transitMaxDays = match.transit_max_days;
      }
    }

    const now = new Date();

    // Determine if order is before daily cutoff; otherwise treat as next business day
    const [cutHour, cutMin] = cutoff.split(':').map(n => parseInt(n, 10));
    const orderDate = new Date(now);
    const cutoffToday = new Date(now);
    cutoffToday.setHours(cutHour, cutMin, 0, 0);

    let placedDate = new Date(now);
    if (now > cutoffToday) {
      placedDate = addBusinessDays(now, 1, disableWeekends, holidays);
    }

    const dispatchStart = addBusinessDays(placedDate, handlingDays, disableWeekends, holidays);
    const dispatchEnd = dispatchStart; // same day dispatch for simplicity

    const deliveryMin = addBusinessDays(dispatchStart, transitMinDays, disableWeekends, holidays);
    const deliveryMax = addBusinessDays(dispatchStart, transitMaxDays, disableWeekends, holidays);

    const rangeEl = root.querySelector('[data-delivery-range]');
    if (rangeEl) rangeEl.textContent = `${formatDate(deliveryMin)} - ${formatDate(deliveryMax)}`;
  }

  function init() {
    document.querySelectorAll('[data-est-delivery]').forEach(applyEstimatedDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Support Theme Editor live updates (Shopify section reloads)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:block:select', init);
})();


